import { useQuery } from "@tanstack/react-query";
import { notificationKeys } from "../notification.keys";
import { notificationApi } from "../service";

/** Headline counts for the admin board: users with push, devices, out of how many. */
export function usePushAdminStats() {
  return useQuery({
    queryKey: notificationKeys.adminStats(),
    queryFn: () => notificationApi.getAdminStats().then((response) => response.data),
  });
}
